import React, { useState } from "react";
import CardImage from "images/vertical_black_card_2.webp";
import GrayCheck from "images/gray_check_icon.svg";
import GrayX from "images/gray_x_icon.svg";
import Logo from "images/tomo_logo_white_green.svg";
import useEasterEgg from "utils/hooks/useEasterEgg";
import PageHeaders from "../common/PageHeaders";
import Menu from "../common/Menu";
import Header from "../components/Header";
import Footer from "../components/Footer";
import StartYourTomorrow from "../components/StartYourTomorrow";
import arman from "../images/peeps/arman.webp";

const Comparison = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { eggs } = useEasterEgg([
    {
      string: "arman",
      image: arman,
      logMessage: "arman, we miss you!",
    },
  ]);

  return (
    <>
      <PageHeaders type="comparison" />
      <div className="flex flex-col h-full" id="outer-container">
        <div className={`relative ${!!menuOpen ? "" : "max-w-page"}`}>
          <Menu
            handleToggle={(state) => {
              setMenuOpen(state.isOpen);
            }}
            hidden={menuOpen}
          />
        </div>
        <div className="mainContent xtopSection" id="page-wrap">
          <div className="headerBar">
            <Header siteTitle={"The card"} />
          </div>
          <div className="flex mt-24">
            <main className="w-full pt-4">
              <div className="mb-8  bannerBackground2">
                <div className="md:flex max-w-page items-center text-center md:text-left">
                  <div className="flex-1">
                    <div className="w-3/4 mx-auto">
                      <h1 className="text-4xl text-white lg:text-5xl xl:text-6xl font-extrabold md:-mt-16">
                        This is your card<span class="text-primary-txt">.</span>
                      </h1>
                      <p className="text-xl text-white lg:text-2xl xl:text-3xl my-4">
                        Created with you in mind.
                      </p>
                    </div>
                  </div>
                  <div className="lg:px-8 mx-auto" style={{ maxWidth: "60%" }}>
                    <img
                      className="mx-auto"
                      src={CardImage}
                      style={{ width: "500px" }}
                    />
                  </div>
                </div>
              </div>

              <div className="max-w-page">
                <h2 className="text-center text-primary text-3xl lg:text-4xl xl:text-5xl font-extrabold">
                  A <span className="text-primary-txt">better</span> choice.
                </h2>
                <div className="comparisonTable md:text-lg m-5 md:m-10 rounded-lg shadow-2xl-around flex flex-col">
                  <div className="text-white bg-primary-dark rounded-t-lg">
                    <div className="font-bold text-primary-txt text-sm md:text-2xl">
                      How we stack up
                    </div>
                    <div>
                      <img className="mx-auto" src={Logo} />
                    </div>
                    <div className="font-bold text-center">Amex (Platinum)</div>
                    <div className="font-bold text-center">Apple Card</div>
                  </div>
                  <div className="bg-gray-200">
                    <div className="font-bold text-sm md:text-base">
                      No credit history required
                    </div>
                    <div>
                      <img className="mx-auto w-6" src={GrayCheck} />
                    </div>
                    <div>
                      <img className="mx-auto w-6" src={GrayX} />
                    </div>
                    <div>
                      <img className="mx-auto w-6" src={GrayX} />
                    </div>
                  </div>
                  <div className="bg-white">
                    <div className="font-bold text-sm md:text-base">
                      Benefits
                    </div>
                    <div>
                      <img className="mx-auto w-6" src={GrayCheck} />
                    </div>
                    <div>
                      <img className="mx-auto w-6" src={GrayCheck} />
                    </div>
                    <div>
                      <img className="mx-auto w-6" src={GrayCheck} />
                    </div>
                  </div>
                  <div className="bg-gray-200">
                    <div className="font-bold text-sm md:text-base">
                      Expedited auto-pay*
                    </div>
                    <div>
                      <img className="mx-auto w-6" src={GrayCheck} />
                    </div>
                    <div>
                      <img className="mx-auto w-6" src={GrayX} />
                    </div>
                    <div>
                      <img className="mx-auto w-6" src={GrayX} />
                    </div>
                  </div>
                  <div className="bg-white">
                    <div className="font-bold text-sm md:text-base">
                      No APR**
                    </div>
                    <div>
                      <img className="mx-auto w-6" src={GrayCheck} />
                    </div>
                    <div>
                      <img className="mx-auto w-6" src={GrayX} />
                    </div>
                    <div>
                      <img className="mx-auto w-6" src={GrayX} />
                    </div>
                  </div>
                  <div className="bg-gray-200 rounded-b-lg">
                    <div className="font-bold text-sm md:text-base">
                      No security deposit
                    </div>
                    <div>
                      <img className="mx-auto w-6" src={GrayCheck} />
                    </div>
                    <div>
                      <img className="mx-auto w-6" src={GrayCheck} />
                    </div>
                    <div>
                      <img className="mx-auto w-6" src={GrayCheck} />
                    </div>
                  </div>
                </div>
                <p className="text-sm text-gray-500 text-center">
                  *Expedited auto-pay represents automatic payments at a rate
                  more frequent than monthly. <br />
                  **Represents both intro and variable APR.
                </p>
              </div>

              <div className="max-w-page border-b border-gray-300 my-20" />

              <div className="max-w-page text-white mb-20">
                <h2 className="text-4xl xl:text-5xl font-extrabold p-8 xl:px-12">
                  Features<span className="text-primary-txt">.</span>
                </h2>
                <div className="md:flex">
                  <div className="md:w-1/2 p-8 xl:px-12">
                    <h3 className="text-xl lg:text-2xl font-bold mb-4">
                      No credit history required.
                    </h3>
                    <p>
                      You are worth more than just a number (a.k.a. an arbitrary
                      credit score). We conduct individualized assessments based
                      on financial history and other sources and use our
                      proprietary algorithm to determine your credit worthiness.
                    </p>
                  </div>
                </div>
                <div className="md:flex">
                  <div className="md:w-1/2 p-8 xl:px-12">
                    <h3 className="text-xl lg:text-2xl font-bold mb-4">
                      Build your credit score.
                    </h3>
                    <p>
                      Through consistent on-time payments, your credit score
                      will grow. Tomo has set up an &quot;optional&quot; 7 day
                      pay to maximize this cycle and increase the rate in which
                      your credit score can improve.
                    </p>
                  </div>
                </div>
                <div className="md:flex">
                  <div className="md:w-1/2 p-8 xl:px-12">
                    <h3 className="text-xl lg:text-2xl font-bold mb-4">
                      Customizable spending power.
                    </h3>
                    <p>
                      Since we do not rely on a credit score to determine your
                      spending power, we have the flexibility to update your
                      spending power in real time! Spending power ranges from
                      $100 - $30,000.*
                    </p>
                    <p className="text-xs mt-4">
                      * Not all applicants will be approved for the maximum
                      spending power.
                    </p>
                  </div>
                </div>
              </div>

              <StartYourTomorrow />
            </main>
          </div>
        </div>
        {eggs}
        <Footer />
      </div>
    </>
  );
};

export default Comparison;
